// extracted by mini-css-extract-plugin
module.exports =  {"overlay":"XdACwMj","content":"vnd4hEa","mobile-full-screen":"RJ6UjZI","mobileFullScreen":"RJ6UjZI","container":"RRT2zas"};